import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  GalleryTypeHeaderTitle,
  ImageItem,
  RequestTemplateContent,
} from "../../../common/statelessView";
import {
  fetchData,
  search,
  closeSlider,
  navigateNow,
  resetPage,
} from "../../../../_actions/sidebarSliderActions";
import {
  wsCopyFromTemplate,
  wsAddLayer,
} from "../../../../_actions/webSocketAction";
import { batch, connect } from "react-redux";
import SuperList from "../mediaPanel/SuperList";
import { GRAPHICS_SLIDER_PANEL, TEMPLATES_SLIDER_PANEL } from "../../constants";
import { withTranslation } from "react-i18next";

class TemplatesCategoryViewAll extends Component {
  render() {
    const { sidebarSlider, t } = this.props;
    const { loaded, payload, hasMore, viewAll } = sidebarSlider;
    const itemClass =
      this.props.panelType === GRAPHICS_SLIDER_PANEL ? "item-element" : "";
    let currentTypePayload = payload || [];
    let childElements = currentTypePayload.map((image, index) => {
      let childPayload = this.preparePayload(image);
      let imageHeight =
        this.props.panelType === GRAPHICS_SLIDER_PANEL
          ? image?.image_width
          : image?.image_height || 200;
      let imageWidth = image?.image_width || 200;
      let itemWidth =
        this.props.panelType === GRAPHICS_SLIDER_PANEL ? 80.656 : "";

      return (
        <div
          key={image.id}
          className={`item ${itemClass}`}
          onClick={() => this.addLayerCallback(childPayload)}
          data-grid-groupkey={image.groupKey}
        >
          <ImageItem
            data={childPayload}
            key={image.id}
            url={childPayload.content?.meta.image}
            alt={image.description}
            width={imageWidth}
            height={imageHeight}
            nativeImageStyles={{
              height:
                ((itemWidth || 152.5) * parseInt(imageHeight)) /
                parseInt(imageWidth),
            }}
            itemWidth={itemWidth}
            hasAction={false}
            index={index}
            modalFor={"template"}
          />
        </div>
      );
    });

    const navigateBack = () => {
      batch(() => {
        this.props.resetPage(this.props.sidebarSlider.searchText);
        this.props.navigateNow();
      });
    };
    const searchPlaceholder =
      this.props.panelType === TEMPLATES_SLIDER_PANEL
        ? t("featured_templates.search_all")
        : t("featured_templates.search_graphics");

    const noResultFound =
      this.props.panelType === TEMPLATES_SLIDER_PANEL
        ? t("errors.not_found")
        : t("errors.not_found");

    return (
      <>
        <SuperList
          list="element-gallery"
          loaded={loaded}
          showNavigation={
            <GalleryTypeHeaderTitle
              moreOpened={true}
              title={viewAll.categoryType}
              toggleMore={navigateBack}
            />
          }
          searchPlaceholder={searchPlaceholder}
          notFound={
            <div className="no-content-container">
              <RequestTemplateContent
                text={noResultFound}
              ></RequestTemplateContent>
            </div>
          }
          hasMore={hasMore}
          loadPage={this.loadPage}
          margin={this.props.panelType === TEMPLATES_SLIDER_PANEL ? 12 : 8}
        >
          {childElements}
        </SuperList>
      </>
    );
  }

  loadPage = (groupKey) => {
    const { searchText, viewAll } = this.props.sidebarSlider;
    if (!searchText) {
      this.props.fetchData("", {
        ...this.props,
        groupKey: groupKey,
        categoryId: viewAll.categoryId,
      });
    } else {
      this.props.search("", searchText, {
        ...this.props,
        groupKey,
        categoryId: viewAll.categoryId,
      });
    }
  };

  preparePayload = (data) => {
    const message = {
      mime: "shape",
      id: data.id,
      type: "component",
      content: {
        meta: {
          ...data,
        },
      },
    };
    return message;
  };

  addLayer = (data) => {
    this.props.wsCopyFromTemplate(this.props.editor.activePage.id, data.id);
  };

  addLayerCallback = async (data) => {
    this.addLayer(data);
    if (this.props.isMobileView) {
      this.props.closeSlider();
    }
  };
}

TemplatesCategoryViewAll.propTypes = {
  page: PropTypes.number.isRequired,
  panelType: PropTypes.string.isRequired,
  sidebarSlider: PropTypes.object.isRequired,
  categoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  categoryType: PropTypes.string,
};

TemplatesCategoryViewAll.defaultProps = {
  page: 1,
};

const mapStateToProps = (state) => ({
  sidebarSlider: state.sidebarSlider,
  editor: state.editor,
  contentSize: state.story.contentSize,
  panelType: state.sidebarSlider.sliderPanelType,
  page: state.sidebarSlider.page,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({
  fetchData: (source, props) => dispatch(fetchData(source, props)),
  search: (source, searchTerm, props) =>
    dispatch(search(source, searchTerm, props)),
  wsCopyFromTemplate: (activePageId, payload) =>
    dispatch(wsCopyFromTemplate(activePageId, payload)),
  wsAddLayer: (activePageId, payload) =>
    dispatch(wsAddLayer(activePageId, payload)),
  closeSlider: () => dispatch(closeSlider()),
  navigateNow: (payload) => dispatch(navigateNow(payload)),
  resetPage: (payload) => dispatch(resetPage(payload)),
});

export default withTranslation(["common"])(
  connect(mapStateToProps, mapDispatchToProps)(TemplatesCategoryViewAll)
);
